// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"232":"sira","841":"studio","860":"radio"}[chunkId] + "." + {"232":"739a3c10","841":"49e66954","860":"934d76be"}[chunkId] + ".js";
};